var ROSLIB = require('roslib');

module.exports = function(connection) {
	//
	this.call = function(name, serviceType, payload) {
		return connection.getInstance().then(function(ros) {
			return new Promise(function(resolve, reject) {
				var service = new ROSLIB.Service({
					ros: ros,
					name: name,
					serviceType: serviceType
				});
				var request = new ROSLIB.ServiceRequest(payload);
				service.callService(request, resolve, reject)
			});
		});
	};
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/roslib-client/src/ServiceManager.js
// module id = 381
// module chunks = 0